<template>
    <c-alert :color="color">
        <slot />
    </c-alert>
</template>
<script setup>
import { CAlert } from '@coreui/vue-pro/dist/esm/components/alert/index.js';

defineProps(['color']);
</script>
